<template>
  <section class="tools">
    <div class="tools--box">
      <div class="tools--text">
        <h3>Training tools:</h3>
      </div>
      <div class="tools--image">
        <a target="_blank" href="https://figma.com">
        <svg
          width="55"
          height="55"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <rect width="55" height="55" fill="url(#pattern0)" />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlink:href="#image0_661_3300" transform="scale(0.0181818)" />
            </pattern>
            <image
              id="image0_661_3300"
              width="55"
              height="55"
              xlink:href="data:image/png;base64,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"
            />
          </defs>
        </svg>
        </a>
        <a target="_blank" href="https://adobe.com/products/photoshop.html">  <img src="@/assets/Curriculum/icons/ps.png" alt=""> </a>
       
        <a target="_blank" href="https://docs.google.com.com"><img src="@/assets/Curriculum/icons/blue.png" alt=""> </a>
       <a target="_blank" href="https://notion.com"> <img src="@/assets/Curriculum/icons/notion.png" alt=""> </a>
        <a target="_blank" href="https://whimsical.com"><img src="@/assets/Curriculum/icons/purple.png" alt=""></a>
        <a target="_blank" href="https://miro.com"><img src="@/assets/Curriculum/icons/yellow.png" alt=""> </a>

      </div>
      <div class="tools--word">
        <div class="bg">
          <img src="./bg.png" alt="">
        </div>
        <h6>
          Basic Requirements : A working laptop and internet access. No previous
          UI/UX Design experience is required. Go Premium Now.
        </h6>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";
@import "@/styles/_typography.scss";
.tools {
  padding: 2rem 7%;
  height: 355px;
  @include flex(flex-start, center);
}
.tools--box {
  @include flex(center, center);
  gap: 4rem;
  .tools--text {
      width: 20%;
    h4 {
      @include sub-heading-bold {
        color: $black-50;
        font-family: $karla;
      }
    }
  }
  .tools--image {
    display: grid;
    width: 40%;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    place-items: center;
  }
  .tools--word {
    /* background-image: url('./bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top; */
      width: 40%;
      margin: auto 0;
      align-self: center;
      position: relative;
      height: auto;
      .bg {
        img {
        position: absolute;
        @include flex(flex-start,center);
        z-index: 1;
        top: -100%;
        }
      }
    h6 {
      z-index: 2;
        align-self: center;
        position: relative;
        z-index: 2;
        margin: auto 0;
      @include caption {
        color: $secondary-80;
        font-family: $karla;
      }
    }
  }
}
@include xl {
  .tools--box {
    height: auto;
  flex-wrap: wrap;
  }
  .tools--word {
    .bg {
      display: none;
    }
  }
}
@include sm {
  .tools {
    height: auto;
  }
  .tools--box {
  .tools--text {
      width: 100%;
    h4 {
      @include sub-heading-bold {
        color: $black-50;
        font-family: $karla;
      }
    }
  }
  .tools--image {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    place-items: center;
    margin: 1rem 0;
  }
  .tools--word {
      width: 100%;
      display: block;
      margin: auto 0;
      align-self: center;
      position: relative;
       h6 {
      @include caption {
        font-size: 0.8rem;
      }
    }
  }
}
}
</style>